import { put, takeEvery } from 'redux-saga/effects'
import { CUSTOMER_UDFS_LOADING, CUSTOMER_UDFS_SUCCESS, CUSTOMER_UDFS_ERROR } from "../actions/actionCustomerUDFs";
import { GetCustomersUdfs } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get customer user defined fields, response status: " + response.status + "\"}]}")
    }
}

function* GetCustomerUserDefinedFields(action) {
    try {
        let udfsresponse = yield fetchAsync(GetCustomersUdfs, action);
        yield put({ type: CUSTOMER_UDFS_SUCCESS, payload: udfsresponse });
    } catch (e) {
        yield put({ type: CUSTOMER_UDFS_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaCustomerUDFs = [
    takeEvery(CUSTOMER_UDFS_LOADING, GetCustomerUserDefinedFields),
];
